import { createContext, useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
    getHotelDetails,
    getRestaurantDetails,
    registeGuest,
} from '../services/apiservice';
import {
    HOTEL_ID,
    IS_TABLE_NO_IN_URL,
    PROPERTY_TYPE,
    TABLE_NO,
    TOKEN,
} from '../constants';
import { isEmpty } from 'lodash';
import { ConfigProvider } from 'antd';

const RestaurantContext = createContext({});
export const useRestaurant = () => useContext(RestaurantContext);

function RestaurantContextProvider(props) {
    const [restaurantDetails, setRestaurantDetails] = useState({});
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    useEffect(() => {
        (() => {
            let entityID;
            let urlEntityID = '';
            let urlPropertyNumber = '';
            let urlTableNumber = '';

            if (location.pathname.includes('welcome')) {
                let splitedLocation = location.pathname.split('/');
                if (
                    splitedLocation.includes('welcome') &&
                    splitedLocation.length >= 3
                ) {
                    urlEntityID = splitedLocation[2];
                    urlPropertyNumber = splitedLocation[3] || '';
                    urlTableNumber = splitedLocation[4] || '';
                }

                const existingRestaurantID = localStorage.getItem(HOTEL_ID);
                const existingPropertyNumber =
                    localStorage.getItem(PROPERTY_TYPE);
                const existingTableNumber = localStorage.getItem(TABLE_NO);
                const isTableNoInUrl = urlTableNumber ? '1' : '0';
                if (urlEntityID) {
                    if (
                        urlEntityID !== existingRestaurantID ||
                        urlPropertyNumber !== existingPropertyNumber ||
                        urlTableNumber !== existingTableNumber
                    ) {
                        localStorage.clear();
                        sessionStorage.clear();
                        entityID = urlEntityID;
                    } else {
                        entityID = existingRestaurantID;
                        urlPropertyNumber = existingPropertyNumber || '';
                        urlTableNumber = existingTableNumber || '';
                    }
                    localStorage.setItem(IS_TABLE_NO_IN_URL, isTableNoInUrl);
                    localStorage.setItem(HOTEL_ID, entityID);
                    if (urlPropertyNumber) {
                        localStorage.setItem(PROPERTY_TYPE, urlPropertyNumber);
                    }
                    if (urlTableNumber) {
                        localStorage.setItem(TABLE_NO, urlTableNumber);
                    }
                    registeUserAsGuest();
                    if (urlEntityID.length > 10) {
                        navigate('/', { replace: true });
                    }
                } else {
                    entityID = existingRestaurantID;
                    if (entityID.length > 10) {
                        navigate('/', { replace: true });
                    }
                }
            }
        })();
    }, [location.pathname]);

    useEffect(() => {
        fetchRestaurantDetails();
    }, []);

    const fetchRestaurantDetails = async () => {
        setLoading(true);
        try {
            const ID = localStorage.getItem(HOTEL_ID);
            const responseRestaurant = await getRestaurantDetails(ID);
            const responseHotel = await getHotelDetails(ID);
            if (
                responseRestaurant.status === 200 &&
                responseHotel.status === 200
            ) {
                const resultRestaurant = responseRestaurant.data?.data || {};
                const resultHotel = responseHotel.data?.data || {};
                const { assets, banner, logo, id } = resultRestaurant;
                const assetsParseed = assets ? JSON.parse(assets) || {} : {};
                if (
                    assetsParseed &&
                    assetsParseed.styles &&
                    assetsParseed.styles.bg_color_category
                ) {
                    document.documentElement.style.cssText = `--primary-color: ${
                        assetsParseed.bg_color_category || '#75716f'
                    }`;
                }
                const data = {
                    ...resultHotel,
                    ...assetsParseed,
                    banner,
                    logo,
                    id,
                };
                // if (pvrName) {
                //     document.body.classList.add(pvrName);
                // }
                setRestaurantDetails(data);
            }
        } catch (error) {
        } finally {
            setLoading(false);
        }
    };
    const getDetailsFromKey = (key) => {
        const { kiosk = {}, outlet = {}, property = {} } = restaurantDetails;

        if (kiosk[key] && !isEmpty(kiosk[key])) {
            return kiosk[key];
        }
        if (outlet[key] && !isEmpty(outlet[key])) {
            return outlet[key];
        }
        if (property[key] && !isEmpty(property[key])) {
            return property[key];
        }
        return null;
    };
    const registeUserAsGuest = async () => {
        try {
            setLoading(true);
            const ID = localStorage.getItem(HOTEL_ID);

            const responseRegister = await registeGuest(ID);
            if (responseRegister.status === 201) {
                const token = responseRegister.data.data.access_token || '';

                localStorage.setItem(TOKEN, token);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };
    const value = {
        restaurantDetails,
        loading,
        getDetailsFromKey,
    };
    return (
        <ConfigProvider
            theme={{
                components: {
                    Button: {
                        colorPrimary: '#061f46',
                        algorithm: true, // Enable algorithm
                    },
                    Input: {
                        colorPrimary: '#061f46',
                        algorithm: true, // Enable algorithm
                    },
                },
            }}
        >
            <RestaurantContext.Provider value={value}>
                {props.children}
            </RestaurantContext.Provider>
        </ConfigProvider>
    );
}

export default RestaurantContextProvider;
